export default function getInitState() {
    return {
        gridIsShow: true,
        formIsShow: false,

        additionalTableConfig: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új alkalmassági vigzsgálat',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            }
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetForm'
            },
            {
                btn_text: '<i class="fas fa-print"></i> Nyomtatás',
                event_name: "customClick",
                class: "btn btn-info my-custom-class mx-1",
                event_payload: 'print'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow'
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                visibility: false,
                formVisible: false
            },
            {
                name: "patientId",
                label: "Páciens ID",
                visibility: false,
                formVisible: false
            },
            {
                name: "profession",
                label: "Szakma",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "company",
                label: "Cég",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "companySite",
                label: "Telephely",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "job",
                label: "Munkakör",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "provider",
                label: "Ellátó",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "examinationDate",
                label: "Vizsgálat dátuma",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "date"
            },
            {
                name: "rowBreak",
                label: "rowBreak",
                rowBreak: true,
                formSize: 6,
                visibility: false,
                formVisible: true
            },
            {
                name: "presentComplaints",
                label: "Jelen panaszok",
                visibility: false,
                formVisible: true,
                formSize: 12,
                formType: "textarea"
            },
            {
                name: "bodyWeight",
                label: "Testsúly",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "text"
            },
            {
                name: "height",
                label: "Testmagasság",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "text"
            },
            {
                name: "bodyMassIndex",
                label: "Testtömeg-index (BMI)",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "text"
            },
            {
                name: "bloodPressure",
                label: "Vérnyomás jobb kar",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "text"
            },
            {
                name: "pulse",
                label: "Pulzus",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "text"
            },
            {
                name: "skinAndVisibleMucosa",
                label: "Bőr és látható nyálkahártya",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "text"
            },
            {
                name: "mouthNoseAndPharynxFormulas",
                label: "Száj, orr és garatképletek",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "text"
            },
            {
                name: "toothCondition",
                label: "Fogazat állapota",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "text"
            },
            {
                name: "lymphNodes",
                label: "Nyirokcsomók",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "text"
            },
            {
                name: "thyroid",
                label: "Pajzsmirigy",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "text"
            },
            {
                name: "heart",
                label: "Szív",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "text"
            },
            {
                name: "ecg",
                label: "EKG",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "text"
            },
            {
                name: "lungs",
                label: "Tüdő",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "text"
            },
            {
                name: "veins",
                label: "Erek",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "text"
            },
            {
                name: "tummy",
                label: "Has",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "text"
            },
            {
                name: "bonesAndJoints",
                label: "Csontok és izületek",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "text"
            },
            {
                name: "flatfoot",
                label: "Lúdtalp",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "text"
            },
            {
                name: "spine",
                label: "Gerinc",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "text"
            },
            {
                name: "nervousSystem",
                label: "Idegrendszer",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "text"
            },
            {
                name: "hearingBetter",
                label: "Hallás jobb",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "text"
            },
            {
                name: "hearingLeft",
                label: "Hallás bal",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "text"
            },
            {
                name: "employabilityRestrictionsOpinion",
                label: "Munkaalkalmasság, korlátozások, vélemény",
                visibility: false,
                formVisible: true,
                formSize: 12,
                formType: "textarea"
            },
            {
                name: "periodicDeclaration",
                label: "Időszakos nyilatkozat",
                visibility: false,
                formVisible: true,
                formSize: 12,
                formType: "textarea"
            },
            {
                name: "createdBy",
                label: "Készítő",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formVisible: false
            },
            {
                name: "createdOn",
                label: "Készítés dátuma",
                visibility: true,
                slot_name: "created_on_format",
                formVisible: false
            },
            {
                name: "modifiedBy",
                label: "Módosító",
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedOn",
                label: "Módosítás dátuma",
                visibility: false,
                formVisible: false
            },
            {
                name: "patient",
                label: "Páciens",
                visibility: false,
                formVisible: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ]
    }
}